export default {"src":"/_next/static/media/scale-gray.f176c385.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};